import './HeaderBar.scss';

import BreadcrumbNavigation from './components/BreadcrumbNavigation';
import SearchInput from './components/SearchInput';
import UserSection from './components/UserSection';

function HeaderBar() {
  return (
    <div className="header-bar">
      <BreadcrumbNavigation />
      <div className="header-bar--right">
        <SearchInput />
        <div className="header-bar__user">
          <UserSection />
        </div>
      </div>
    </div>
  );
}

export default HeaderBar;
